import { getTransactionActivities } from 'api/Transaction';

import { cn } from 'lib/helpers/utility';
import { useReceipt } from 'lib/hooks/queries/billing/useReceipt';

import Loader from 'components/shared/Loader/Loader';
import Receipt from 'components/shared/Receipt/Receipt';
import ExpandableToolbar from 'components/shared/ExpandableToolbar/ExpandableToolbar';

// Sub-modal presentation of the receipt. Props are read through a ref so the sheet
// always sees the host component's latest values; mounting only while the sheet is
// open replaces the fallback modal's isOpen gate on the query.
const ReceiptSheet = ({ propsRef }) => {
  const {
    transactionId,
    appointmentId,
    eobId,
    token,
    viewDefaultReceipt,
    walkout,
    kioskDevice,
    isPatient
  } = propsRef.current;

  const { data, isLoading } = useReceipt({
    params: { transactionId, appointmentId, eobId, token },
    dependencies: [transactionId, appointmentId, eobId, token],
    options: { enabled: (!!transactionId || !!appointmentId || !!eobId) && viewDefaultReceipt }
  });

  const receipt = data?.receipt;

  return (
    <div className={cn('flex h-full min-h-0 w-full flex-1', kioskDevice && '[zoom:1.3]')}>
      {isLoading ? (
        <div className="flex flex-1 items-center justify-center">
          <Loader color="primary" size={40} />
        </div>
      ) : (
        receipt && <Receipt receipt={receipt} walkout={walkout} isPatient={isPatient} />
      )}
      {!isLoading && !isPatient && (
        <ExpandableToolbar
          category="transaction"
          id={receipt?.transaction?.id}
          fetchData={getTransactionActivities}
        />
      )}
    </div>
  );
};

export default ReceiptSheet;
